@for(group of groups; track group.label; let idx = $index) {
  @if(selectedGroupIndex === idx) {
    @if(group.component) {
      <section class="group-shell">
        @if(showBreadcrumb) {
          <app-breadcrums
            [breadcrumList]="breadcrumList"
            [groups]="groups"
            [selectedGroupIndex]="selectedGroupIndex"
            [onGroupChange]="onGroupChange">
          </app-breadcrums>
        }
        <div class="group-content">
          <ng-container *ngComponentOutlet="group.component; inputs: group.inputs"></ng-container>
        </div>
      </section>
    } @else {
      <section class="group-shell">
        <div class="group-content">
          <app-page-container
            [layoutType]="LayoutType.IntegratedTab"
            [tabConfig]="group.tabs ?? []"
            [title]="title"
            [props]="props"
            [showBreadcrumb]="showBreadcrumb"
            [groups]="groups"
            [selectedGroupIndex]="selectedGroupIndex"
            [onGroupChange]="onGroupChange">
          </app-page-container>
        </div>
      </section>
    }
  }
}
